<template>
  <div>
    <TextEpsilon
      tag="dt"
      class="name"
      v-text="name"
    />
    <dd class="value">
      <slot/>
    </dd>
  </div>
</template>

<script>
  import TextEpsilon from './TextEpsilon';

  export default {
    components: { TextEpsilon },
    props: {
      name: {
        type: String,
        required: true,
      },
    },
  };
</script>

<style
  scoped
  lang="scss"
>
  .name {
    color: color(light-grey);
  }

  .value {
    .name + & {
      margin-top: spacing(base-beta);
    }
  }
</style>
